/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { connect } from 'react-redux';
// actual presentational component that will utilize application state and actions (will be exported after being infused with state/actions)
import { setSelectedImage, setPreviewImage } from 'state/actions/embedsState/embedManagementState/content_status';
import {clearImageTab} from 'state/actions/embedsState/embedManagementState/image_status';
import ImageAPI from 'material/embeds/imageapi/imageapi';


/* ========== ~~~~~~~~~~ IMAGE API : PARENT ~~~~~~~~~~ ========== */
// CONTAINER COMPONENT
// interacts with redux (store of application state)
// infuses child component (imported above) with state & actions by mapping and then connecting them

// map state
const mapStateToProps = ({ embedsState, sessionStatus }) => ({
    activeSelection: embedsState.embedManagementState.contentStatus.activeSelection, // background, questionImage, option_0, option_1, option_2, option_3
    clientUUID: sessionStatus.clientUUID, // client ID used to make call for users uploaded images
    newUpload: embedsState.embedManagementState.contentStatus.newUpload,
    pageCount: embedsState.embedManagementState.imageStatus.page_count
});

const mapDispatchToProps = dispatch => ({
    setSelectedImage: (provider, imageId, imageURL) => dispatch(setSelectedImage(provider, imageId, imageURL)),// provider: USAToday, SIPA
    setPreviewImage: imageURL => dispatch(setPreviewImage(imageURL)),
    clearImageTab: () => dispatch(clearImageTab())
});


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// utilizes "connect" functionality from redux in order to infuse state/actions as props to child component
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ImageAPI);